import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

import { connect } from "react-redux";
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import { ROUTES } from "../../routes";
import { useLanguage } from '@languages/index';


const images = [
  '/assets/images/lookbook/woman_01.png',
  '/assets/images/lookbook/woman_02.png',
  '/assets/images/lookbook/woman_03.png',
  '/assets/images/lookbook/woman_04.png',
  '/assets/images/lookbook/woman_05.png',
  '/assets/images/lookbook/woman_06.png',
  '/assets/images/lookbook/woman_07.png',
  '/assets/images/lookbook/woman_08.png',
  '/assets/images/lookbook/woman_09.png',
  '/assets/images/lookbook/woman_10.png',
  '/assets/images/lookbook/woman_11.png',
  '/assets/images/lookbook/woman_12.png',
  '/assets/images/lookbook/woman_13.png',
  '/assets/images/lookbook/woman_14.png',
  '/assets/images/lookbook/man_01.png',
  '/assets/images/lookbook/man_02.png',
  '/assets/images/lookbook/man_03.png',
  '/assets/images/lookbook/man_04.png',
  '/assets/images/lookbook/man_05.png',
  '/assets/images/lookbook/man_06.png',
  '/assets/images/lookbook/man_07.png',
  '/assets/images/lookbook/man_08.png',
  '/assets/images/lookbook/man_09.png',
  '/assets/images/lookbook/man_10.png',
  '/assets/images/lookbook/man_11.png',
  '/assets/images/lookbook/man_12.png',
  '/assets/images/lookbook/man_13.png',
  '/assets/images/lookbook/man_14.png',
];


const LookbookIndex = (props) => {
  const navigate = useNavigate();

  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.lookbook };

  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const scrollContainerRef = useRef(null);
  const { scrollY } = useScroll({
    container: scrollContainerRef,
  });

  useMotionValueEvent(scrollY, "change", (latest) => {
    const nextState = latest > 2000 ? true : false;
    if (showFloatingButtons != nextState) {
      setShowFloatingButtons(nextState);
    }
  });

  const footerAnimVariants = {
    hidden: { opacity: 0, y: 300 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div>
      <div
        ref={scrollContainerRef}
        style={{
          maxHeight: "100dvh",
          overflow: "scroll",
        }}
      >
        <div className="md:max-w-[480px] mx-auto">
          <div style={{ height: `${props.preferences.headerHeight}px` }} />
          <div className="mt-[100px] md:mt-[150px] text-center">
            <div className="text-[9px] md:text-[14px] lg:text-[16px]">INFLUENCER LOOKBOOK CREATED BY ONEULOOK</div>
            <div className="mt-[15px] text-[28px] md:text-[42px] lg:text-[56px] font-bold leading-tight tracking-tighter">
              {languageTexts._index_text_1()}
            </div>
          </div>
          <div className="mt-[100px] md:mt-[150px]">
            {images.map((image, i) => {
              return (
                <div key={i} className="flex flex-col 2xl:odd:ml-auto 2xl:even:mr-auto rounded-xl select-none">
                  <img className="w-full h-full pb-[3px]" src={image} />
                </div>
              )
            })}
          </div>
          <div className="h-[100px]" />
        </div>
      </div>

      <motion.div
        className="fixed bottom-0 left-0 right-0 md:mb-[40px]"
        variants={footerAnimVariants}
        initial={"hidden"}
        animate={showFloatingButtons ? "show" : "hidden"}
        transition={{ type: "just" }}
      >
        <div className="cursor-pointer mt-[-1px] justify-center flex flex-row items-center border-t border-[#E8E8E8] md:border-0 md:gap-[12px] select-none">
          {/* <div
            className="bg-[#000000] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px] break-keep max-h-[60px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              openPDF();
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              소개서 다운받기
            </span>
          </div> */}
          <div
            className="bg-[#FF0099] flex flex-1 flex-col justify-center items-center md:rounded-full md:max-w-[248px] md:ml-auto md:mr-[40px]"
            style={{
              boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.25)",
            }}
            onClick={() => {
              navigate(ROUTES.CAMPAIGN_INDEX.PATH);
            }}
          >
            <span className="text-[16px] font-bold text-center text-[#FFF] px-[40px] py-[18px]">
              {languageTexts.start2}
            </span>
          </div>
        </div>
      </motion.div>

    </div>
  )
};
export default connect(mapStateToProps, mapDispatchProps)(LookbookIndex);
